const OurStats = () => {
  return (
    <section
      id="counter"
      className="section-padding bg-image overlay-dark dark-bg"
      style={{
        backgroundImage:
          "linear-gradient(135deg, #1a2230 0%, #111826 55%, #0d121b 100%)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed", // optional parallax-like effect
      }}
    >
      <div className="container text-center">
        <h3>Our Stats</h3>
        <br />
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-lightbulb" />
            </div>
            <h1 className="counter-title counter-num">300+</h1>
            <h5 className="counter-sub-title">
              Happy Clients<br /> Worldwide
            </h5>
          </div>
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-case" />
            </div>
            <h1 className="counter-title counter-num">15+</h1>
            <h5 className="counter-sub-title">
              Varied Industry <br />VerticalsServed
            </h5>
          </div>
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-heart" />
            </div>
            <h1 className="counter-title counter-num">100%</h1>
            <h5 className="counter-sub-title">
              Client Satisfaction <br />& Retention Rate
            </h5>
          </div>
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-cup" />
            </div>
            <h1 className="counter-title counter-num">13+</h1>
            <h5 className="counter-sub-title">
              Yrs of Development Experience
            </h5>
          </div>
        </div>
      </div>
    </section>
  );
};
export default OurStats;
